var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"contact-us"},[_c('p',[_c('small',[_vm._v("©2024, DFCD INTERIOR DESIGN")])])])])])
}]

export { render, staticRenderFns }